/* eslint-disable no-nested-ternary */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import ExternalRedirect from '../LoginView/ExternalRedirect';

class SSO extends React.Component {
  constructor(props) {
    super(props);
    const { clearLoginStatus } = this.props;
    clearLoginStatus();
  }

  componentDidMount() {
    localStorage.removeItem('refresh-token-inprogress');
    const { location: { protocol, hostname }, clientIdParam } = window;
    const responseTypeParam = 'response_type=code';
    const redirectUriParam = `redirect_uri=${protocol}//${hostname}/sso-login`;
    const clientId = `client_id=${clientIdParam}`;
    const scope = 'scope=SOLUMINA';
    const endPoint = '/solumina-auth/oauth2/authorize';
    const { location, postLogin } = this.props;
    const { SSO_Token: ott, code } = queryString.parse(location.search);
    const SSOToken = `SSO_Token=${ott}`;
    const authUrl = `${protocol}//${hostname}${endPoint}?${responseTypeParam}&${clientId}&${redirectUriParam}&${scope}&${SSOToken}`;
    if (typeof (ott) !== 'undefined' && ott != null) {
      window.location.href = authUrl;
    }
    if (typeof (code) !== 'undefined' && code != null) {
      postLogin(code, protocol, hostname);
    }
  }

  render() {
    const { loginStatus, redirectTo, invalidLicense, msg } = this.props;
    if (loginStatus) {
      return (<ExternalRedirect loc={redirectTo} />);
    }
  return (
    <div>
      {invalidLicense
              ? (msg === 'License Expired' ? <FormattedMessage id="messages.expired.license" />
                     : (msg === 'License Unavailable' ? <FormattedMessage id="messages.unavailable.license" />
                                                                 : 'This is SSO Enabled Application'))
              : msg || 'This is SSO Enabled Application'}
    </div>
  );
  }
}

SSO.defaultProps = {
  redirectTo: '',
  invalidLicense: false,
  msg: ''
};

SSO.propTypes = {
  loginStatus: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
  postLogin: PropTypes.func.isRequired,
  clearLoginStatus: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  invalidLicense: PropTypes.bool,
  msg: PropTypes.string
};

export default SSO;